// 学生做题统计信息
import request from '@/router/axios';

let urlPrefix = '/api/exam/etuserquestionhistory';

/**
 * 获取学生做题统计信息
 */
export const selectUserTotal = () => {
    return request(`${urlPrefix}/selectUserTotal`);
};